export const ASHLEY_PROMPTS = Object.freeze({
  UNKNOWN_COMMAND:
    "I didn't catch that. Try saying 'Open Payroll', 'Create Client', or 'Start Break'.",
  UNKNOWN_COMMAND_RETRY:
    "I'm sorry, I didn't quite understand that. Could you say that again?",
  NO_SPEECH: "I didn't hear anything. Try again.",
  MIC_DENIED: "Microphone access is required for voice commands.",
  UNSUPPORTED_BROWSER:
    "Voice commands are not supported in this browser. Please use Chrome or Safari.",
  ACCESS_DENIED: "You don't have access to that.",
  NO_ACTIVE_SESSION: "You need an active session for that.",
  NO_ACTIVE_SESSION_MATERIALS:
    "You need an active session to add materials.",
  START_BREAK_SUCCESS: "Break started.",
  STOP_BREAK_SUCCESS: "Break ended.",
  ALREADY_ON_BREAK: "You are already on break.",
  NOT_ON_BREAK: "You are not currently on break.",
  RECOGNITION_ERROR: "Something went wrong with voice recognition. Please try again.",
  EMAIL_NOT_CONNECTED:
    "I don't have access to your email yet. Connect your Gmail account from Ashley Settings to enable email support.",
  EMAIL_OPENING: "Opening your inbox.",
  EMAIL_SUMMARY_FAILED: "I couldn't reach your email right now. Please try again in a moment.",
  EXECUTIVE_BRIEFING_START: "Certainly. Here's your Executive Briefing.",
});
